module.exports = __webpack_public_path__ + "img/img/logo.30652c7a.png";